"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4202],{

/***/ 44202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0118 6C12.118 6 13.0147 5.10457 13.0147 4C13.0147 2.89543 12.118 2 11.0118 2C9.90559 2 9.00884 2.89543 9.00884 4C9.00884 5.10457 9.90559 6 11.0118 6ZM19.9249 18.6L17.9219 13.6C17.8218 13.2 17.4212 13 17.0206 13H12.0133V9C12.0133 8.4 11.6127 8 11.0118 8C10.4109 8 10.0103 8.4 10.0103 9V14C10.0103 14.6 10.4109 15 11.0118 15H16.3196L18.0221 19.4C18.2224 19.8 18.5228 20 18.9234 20C19.0236 20 19.1237 20 19.324 19.9C19.9249 19.7 20.1252 19.1 19.9249 18.6ZM10.0103 20.0004C11.4124 20.0004 12.8144 19.4004 13.8159 18.3004C14.1163 17.9004 14.7172 17.9004 15.1178 18.2004C15.5184 18.6004 15.6186 19.2004 15.218 19.6004C13.9161 21.1004 12.0133 22.0004 10.0103 22.0004C6.10457 22.0004 3 18.9004 3 15.0004C3 12.8004 4.10162 10.6004 5.90427 9.30044C6.40501 9.00044 7.00589 9.00044 7.30633 9.50044C7.60677 10.0004 7.50663 10.6004 7.10604 10.9004C5.80412 11.9004 5.00295 13.4004 5.00295 15.0004C5.00295 17.8004 7.20619 20.0004 10.0103 20.0004Z"
}), "Accessibility"));


/***/ })

}]);